import React, { useState, useEffect, Fragment } from "react"
import { useSelector } from "react-redux"
import { FaBars } from "react-icons/fa"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import TdSidebar from "./TdSidebar"
import useTdOnBlur from "./useTdOnBlur"
import TdBoxMovable from "./TdBoxMovable"
import { KitchenTablesLegend, KitchenTableLevels } from "components"
import classes from "./index.module.scss"

const TableDecoration = () => {
  const i18n = useTranslation()[1]

  const kitchenTables =
    useSelector(state => state.kitchenTables)

  const initialTablesState = kitchenTables

  const initialSelectedLevelState =
    kitchenTables[0]?.level || ""

  const [tables, setTables] = useState(initialTablesState)
  const [openTableSidebar, setOpenTableSidebar] = useState(false)
  const [selectedFloor, setSelectedFloor] = useState(initialSelectedLevelState)

  useTdOnBlur(tables)

  useEffect(() => {
    setTables(kitchenTables)
  }, [kitchenTables])

  const thisLevelTables =
    tables.filter(t => t.level === selectedFloor)

  const noTables = tables.length === 0

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <TdSidebar
        tables={tables}
        setTables={setTables}
        noTables={noTables}
        openTableSidebar={openTableSidebar}
        setOpenTableSidebar={setOpenTableSidebar}
        setSelectedFloor={setSelectedFloor}
        thisLevelTables={thisLevelTables}
      />

      <div
        className={clsx(
          classes["right"],
          isLtr && classes["right-ltr"]
        )}
      >
        <div className={classes["topbar"]}>
          <button
            id="table-hamburger-button"
            className={classes["button"]}
            onClick={() => setOpenTableSidebar(prev => !prev)}
          >
            <FaBars
              size={20}
              color="white"
            />
          </button>

          <KitchenTablesLegend />
        </div>

        <KitchenTableLevels
          tables={tables}
          selectedFloor={selectedFloor}
          setSelectedFloor={setSelectedFloor}
        />

        <div
          id="tables-container"
          className={classes["boxes"]}
        >
          {thisLevelTables.map(table =>
            table.available &&
            <TdBoxMovable
              key={table._id || table.tableNumber}
              table={table}
              setTables={setTables}
            />
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default TableDecoration